import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import './App.css';

import Home from './pages/Home';
import News from './pages/News';
import Forms from './pages/Forms';
import Vacancies from './pages/Vacancies';
import Onboarding from './pages/Onboarding';
import OurParks from './pages/OurParks';
import EmployeeBenefits from './pages/EmployeeBenefits';
import Suggestions from './pages/Suggestions';
import Chatroom from './pages/Chatroom';
import ScrollToTop from './components/ScrollToTop';
import Directory from './pages/Directory';
import OurValues from './pages/OurValues';
import PrivacyPolicy from './policy/PrivacyPolicy';
import CookiesPolicy from './policy/CookiesPolicy';
import DataProtectionPolicy from './policy/DataProtectionPolicy';
import TermsOfUse from './policy/TermsOfUse';

import ProtectedRoute from './components/Login/ProtectedRoute';
import { NotificationProvider } from './context/NotificationContext';
import { NewsProvider } from './context/NewsContext';
import { VacancyProvider } from './context/VacancyContext';
import { msalConfig } from './authConfig';
import Qms from './pages/Qms';

const msalInstance = new PublicClientApplication(msalConfig);

function App() {
  return (
    <MsalProvider instance={msalInstance}>
      <NotificationProvider>
        <NewsProvider>
          <VacancyProvider>
            <Router>
              <ScrollToTop />

              <div className="App">
                <ProtectedRoute>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/directory" element={<Directory />} />
                    <Route path="/qms" element={<Qms />} />
                    <Route path="/whats-happening" element={<News />} />
                    <Route path="/ourvalues" element={<OurValues />} />
                    <Route path="/onboarding" element={<Onboarding />} />
                    <Route path="/forms" element={<Forms />} />
                    <Route path="/vacancies" element={<Vacancies />} />
                    <Route path="/ourparks" element={<OurParks />} />
                    <Route path="/employeebenefits" element={<EmployeeBenefits />} />
                    <Route path="/suggestions" element={<Suggestions />} />
                    <Route path="/chatroom" element={<Chatroom />} />
                    <Route path="/policy/privacy" element={<PrivacyPolicy />} />
                    <Route path="/policy/cookies" element={<CookiesPolicy />} />
                    <Route path="/policy/data-protection" element={<DataProtectionPolicy />} />
                    <Route path="/policy/terms" element={<TermsOfUse />} />
                    </Routes>
                </ProtectedRoute>
              </div>
            </Router>
          </VacancyProvider>
        </NewsProvider>
      </NotificationProvider>
    </MsalProvider>
  );
}

export default App;